import {
    sendAudioOnOffForParticipantDataTrack,
    sendRemoveParticipantByHostDataTrack,
    sendVideoOnOffForParticipantDataTrack,
} from "../../../shared/dataTrackFunction";
import reduxStore from "../../../configureEnvStore";
import { ENABLED, LOCAL_STORAGE_KEYS } from "../../../constants/Constants";
import { CALL_DATA, GLOBAL_MEETING_DATA } from "../../../constants/PublicVariables";
import {
    setAudioStartNotificationReceivedFromHostModalOpen,
    setIsUnableToJoinCallModalOpen,
    setScreenShareStartNotificationReceivedFromHostModalOpen,
    setVideoStartNotificationReceivedFromHostModalOpen,
} from "../../../reducers/common-reducer";
import storage from "../../../services/storage";
import { LogFirebase } from "../../../services/firestore";
import googleEvent from "../../../services/googleEvent";
import { EVENT_NAME } from "../../../constants/GTagConstants";
import { FIREBASE_EVENT_CATEGORY } from "../../../constants/FirebaseConstants";

export const removeAllUserByHost = () => {
    LogFirebase(FIREBASE_EVENT_CATEGORY.HOST_CONTROLLED_PARTICIPANTS, "REMOVE_ALL_PARTICIPANTS_FUNC", "ENDCALL_TAPPED");
    sendRemoveParticipantByHostDataTrack("2"); // 1: for individual and 2: for remove all
};

export const handleAudioOffForAllParticipantRemotelyByHost = () => {
    googleEvent.logEvent(EVENT_NAME.TURN_ALL_MICS_OFF_TAPPED);
    LogFirebase(FIREBASE_EVENT_CATEGORY.HOST_CONTROLLED_PARTICIPANTS, "TURN_ALL_MICS_OFF_TAPPED", "");
    sendAudioOnOffForParticipantDataTrack("2"); // 1: mute, 0: unmute, 2: mute for all user
};

export const handleVideoOffForAllParticipantRemotelyByHost = () => {
    googleEvent.logEvent(EVENT_NAME.TURN_ALL_CAMS_OFF_TAPPED);
    LogFirebase(FIREBASE_EVENT_CATEGORY.HOST_CONTROLLED_PARTICIPANTS, "TURN_ALL_CAMS_OFF_TAPPED", "");
    sendVideoOnOffForParticipantDataTrack("2"); // 2: stop for all user
};

export const rejoinNotllowed = () => {
    const removeRejoinData = storage.get(LOCAL_STORAGE_KEYS.NOT_ALLOWED_TO_REJOIN_PARTICIPANT);
    if (
        removeRejoinData?.rejoinNotAllowed === ENABLED &&
        !GLOBAL_MEETING_DATA.isAgent &&
        removeRejoinData?.sessionId == GLOBAL_MEETING_DATA.sessionId
    ) {
        if (CALL_DATA.rejoinPopupNotShow) {
            LogFirebase(FIREBASE_EVENT_CATEGORY.HOST_CONTROLLED_PARTICIPANTS, "Rejoin_Not_Allowed", "true");
            setTimeout(() => {
                CALL_DATA.rejoinPopupNotShow = false;
            }, 1000);
        } else {
            LogFirebase(FIREBASE_EVENT_CATEGORY.HOST_CONTROLLED_PARTICIPANTS, "Rejoin_Not_Allowed", "popup_show");
            reduxStore.dispatch(setIsUnableToJoinCallModalOpen(true));
        }
        return true;
    } else {
        return false;
    }
};

export const removeVideoNotificationModal = () => {
    const { videoStartNotificationReceivedFromHostModalOpen } = reduxStore.getState().commonReducer;
    if (videoStartNotificationReceivedFromHostModalOpen) {
        LogFirebase(FIREBASE_EVENT_CATEGORY.HOST_CONTROLLED_PARTICIPANTS, "remove_Video_notificition", "true");
        reduxStore.dispatch(setVideoStartNotificationReceivedFromHostModalOpen(false));
    }
};

export const removeAudioNotificationModal = () => {
    const { audioStartNotificationReceivedFromHostModalOpen } = reduxStore.getState().commonReducer;
    if (audioStartNotificationReceivedFromHostModalOpen) {
        LogFirebase(FIREBASE_EVENT_CATEGORY.HOST_CONTROLLED_PARTICIPANTS, "remove_Audio_notificition", "true");
        reduxStore.dispatch(setAudioStartNotificationReceivedFromHostModalOpen(false));
    }
};

export const removeScreenshareNotificationModal = () => {
    const { screenShareStartNotificationReceivedFromHostModalOpen } = reduxStore.getState().commonReducer;
    if (screenShareStartNotificationReceivedFromHostModalOpen) {
        LogFirebase(FIREBASE_EVENT_CATEGORY.HOST_CONTROLLED_PARTICIPANTS, "remove_Screen_Share_notificition", "true");
        reduxStore.dispatch(setScreenShareStartNotificationReceivedFromHostModalOpen(false));
    }
};
